<template>
    <div class="echart_view" :style="{width: width + 'px'}">
        <div class="left_box">
            <div class="title">{{title}}</div>
            <div v-if="two === 1">
                <div class="one">
                    已注册
                    <span class="num reg_num">{{echart_data.reg_count}}</span>
                    人
                </div>
                <div class="one">
                    待注册
                    <span class="num">{{echart_data.not_reg_count}}</span>
                    人
                </div>
            </div>
            <div v-if="two === 2">
                <div class="one">
                    已填报
                    <span class="num reg_num">{{echart_data.fill_count}}</span>
                    人
                </div>
                <div class="one">
                    待填报
                    <span class="num">{{echart_data.not_fill_count}}</span>
                    人
                </div>
            </div>
            <div v-if="two === 3">
                <div class="one">
                    待提醒患者
                    <span class="num reg_num">{{echart_data.remind_count}}</span>
                    人
                </div>
                <div class="one">&nbsp;</div>
            </div>

        </div>
        <div class="right_box">
            <div :id="echart_id" class="my_chart"></div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts'
    export default {
        name: "echartsView",
        data() {
            return {
                form: {
                    title: 'REP',
                    one: '20',
                    two: '40',
                    province: '山东'
                }
            }
        },
        props: [
            'echart_data',
            'one',
            'two',
            'width'
        ],
        computed: {
            echart_id() {
                return `myEchartOne${this.one}Two${this.two}`
            },
            title() {
                return this.two === 1 ? 'REP注册率' : this.two === 2 ? 'REP填报率' :this.two === 3 ? '待提醒复购比例' : ''
            },
        },
        watch: {
            echart_data: {
                handler: function() {
                    this.drawEchart()
                },
                deep: true
            }
        },
        mounted() {
            this.drawEchart()
        },
        methods: {
            drawEchart() {
                const that = this;
                let myChart = echarts.init(document.getElementById(that.echart_id));

                let name = [], title = '', data = [];
                switch (this.two) {
                    case 1:
                        name = ['注册', '待注册'];
                        title = 'REP注册率';
                        data = [
                            {value: this.echart_data.reg_count, name: '注册'},
                            {value: this.echart_data.not_reg_count, name: '待注册'},
                        ];
                        break;
                    case 2:
                        name = ['填报', '待填报'];
                        title = 'REP填报率';
                        data = [
                            {value: this.echart_data.fill_count, name: '填报'},
                            {value: this.echart_data.not_fill_count, name: '待填报'},
                        ];
                        break;
                    case 3:
                        name = ['待提醒', '正常状态'];
                        title = '待提醒复购比例';
                        data = [
                            {value: this.echart_data.remind_count, name: '待提醒'},
                            {value: this.echart_data.not_remind_count, name: '正常状态'},
                        ];
                        break;
                }

                let color = ['#ccc', '#0f0f0f'];
                myChart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        data: name,
                        left:"center",
                        top:"bottom",
                        orient:"horizontal",
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    series: [
                        {
                            name: title,
                            type: 'pie',
                            radius: ['50%', '70%'],
                            center: ['50%', '50%'],
                            animationDuration: 2000,
                            avoidLabelOverlap: false,
                            // hoverAnimation: false,
                            // silent: true,
                            label: {
                                show: true,
                                position: 'center',
                                formatter: function (val) {
                                    let num = 0;
                                    if ((data[0].value + data[1].value) > 0) {
                                        num = data[0].value / (data[0].value + data[1].value) * 100;
                                    }
                                    return num.toFixed(0) + '%'
                                },
                                textStyle: {
                                    fontSize: 30,
                                }
                            },
                            emphasis: {
                                show: true,
                                label: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: data,
                        }
                    ]
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .echart_view {
        /*width: 400px;*/
        height: 100%;
        display: flex;
        .left_box {
            flex: 1;
            padding: 10px;
            box-sizing: border-box;
            align-self: center;
            .title {
                font-size: 1.4rem;
                font-weight: 600;
                border-bottom: 1px solid #DCDFE6;
                padding: 10px 0;
                box-sizing: border-box;
            }
            .one {
                font-size: 1rem;
                padding: 5px 0;
                .num {
                    font-size: 1.4rem;
                    font-weight: 600;
                    color: #595959;
                    padding: 0 5px;
                }
                .reg_num {
                    color: #00599C;
                }
            }
        }
        .right_box {
            flex: 0 0 200px;
            height: 200px;
            .my_chart {
                width: 200px;
                height: 200px;
            }
        }
    }
</style>